import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import ListItem from 'components/atoms/Lists/ListItem/ListItem';
import Typography from 'components/atoms/Text/Typography/Typography';
import {useClientTeamMembers} from 'services/client/team/team.utils';
import ActionAvatar from 'components/molecules/Avatars/ActionAvatar/ActionAvatar';
import utils from 'helpers/utils';
import ListItemButton from 'components/atoms/Buttons/ListItemButton/ListItemButton';
import StyledUserList from 'components/molecules/Lists/UserList/UserList.styles';
import {useAuthTeamId} from 'components/organisms/Providers/AuthProvider/AuthProvider';
import Icon from 'components/atoms/Icons/Icon/Icon';
import Close from '@mui/icons-material/Close';
import Box from 'components/atoms/Layout/Box/Box';

const UserList = React.forwardRef((props, ref) => {
  const {
    user,
    proxies,
    removeEnabled,
    onClick,
    ...innerProps
  } = useComponentProps(props, 'UserList');

  const teamId = useAuthTeamId();
  const teamMembers = useClientTeamMembers(teamId, proxies);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleClick = (member) => {
    return (e) => {
      onClick?.(e, member?.profile ?? member);
    }
  }

  const selectedMemberIdx = (teamMembers ?? []).findIndex((member) => +member.userId === +user?.userId);
  useEffect(() => {
    setSelectedIndex(selectedMemberIdx);
  }, [selectedMemberIdx]);

  const handleSelectionChange = (e, idx) => {
    setSelectedIndex(idx);
  }

  return <StyledUserList ref={ref} {...innerProps}
                         divider={true}
                         onSelectionChange={handleSelectionChange}
                         selectedIndex={selectedIndex}>
    {teamMembers?.map((member) => {
      const avatar = `${utils.personName(member.profile.firstName, member.profile.lastName)} (${member.profile.username})`;
      const name = utils.personName(member.profile.firstName, member.profile.lastName);
      const color = utils.string2Color(avatar);
      const selected = +member.userId === +user?.userId;

      return <ListItem key={member.userId}>
        <ListItemButton onClick={handleClick(member)} selected={selected}>
          <ActionAvatar action={{
                          label: utils.avatarLabel(avatar),
                          tooltip: avatar
                        }}
                        size="small"
                        color={color}
                        TooltipProps={{enterDelay: 0}}/>
          <Typography variant="body2"
                      min={8} max={20}>{name}</Typography>
          {(removeEnabled && selected) ? <Icon size="smaller" color="text.secondary" icon={Close}/> : null}
        </ListItemButton>
      </ListItem>
    })}
    {teamMembers.length === 0 ? <Box className="UserList-empty">
      <Typography variant="body2">No users found</Typography>
    </Box> : null}
  </StyledUserList>
});

UserList.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  user: PropTypes.object,
  teamMembers: PropTypes.bool,
  proxies: PropTypes.bool,
  removeEnabled: PropTypes.bool,
  onClick: PropTypes.func
};

export default UserList;
